import * as actionTypes from '../../constants/actionTypes';

const initialState = {
  image1: null,
  image2: null,
  image3: null,
  isUploadInProgress: false,
  isCreateIssueInProgress: false,
  isGetSegmentInProgress: false,
  isEditSegmentInProgress: false,
  segmentName: '',
  products: [],
};

export default function(state = initialState, action) {
  switch (action.type) {
    case actionTypes.UPLOAD_IMAGE_SUCCESS:
    case actionTypes.DELETE_IMAGE_SUCCESS:
      if (action.payload.type === 'segment') {
        return Object.assign({}, state, {
          [action.payload.key]: action.payload.image,
        });
      } else {
        return state;
      }
    case '@@redux-form/RESET':
      if (
        action.meta.form === 'addNewSegment' ||
        action.meta.form === 'editSegment'
      ) {
        return initialState;
      } else {
        return state;
      }
    case actionTypes.GET_SEGMENT_SUCCESS:
      return Object.assign({}, state, {
        segmentName: action.payload.segment.name,
        image1:
          (action.payload.segment.images[0] &&
            action.payload.segment.images[0]) ||
          null,
        image2:
          (action.payload.segment.images[1] &&
            action.payload.segment.images[1]) ||
          null,
        image3:
          (action.payload.segment.images[2] &&
            action.payload.segment.images[2]) ||
          null,
        products: action.payload.segment.products.map(product => {
          return { label: product.name, value: product.skuCode };
        }),
      });
    case actionTypes.SHOW_LOADER:
      switch (action.payload) {
        case actionTypes.DELETE_IMAGE:
        case 'ALL':
          return Object.assign({}, state, { isUploadInProgress: true });
        case actionTypes.CREATE_SEGMENT:
          return Object.assign({}, state, { isCreateSegmentInProgress: true });
        case actionTypes.GET_SEGMENT:
          return Object.assign({}, state, { isGetSegmentInProgress: true });
        case actionTypes.EDIT_SEGMENT:
          return Object.assign({}, state, { isEditSegmentInProgress: true });
        default:
          return Object.assign({}, state);
      }
    case actionTypes.HIDE_LOADER:
      switch (action.payload) {
        case actionTypes.DELETE_IMAGE:
        case 'ALL':
          return Object.assign({}, state, { isUploadInProgress: false });
        case actionTypes.CREATE_SEGMENT:
          return Object.assign({}, state, { isCreateSegmentInProgress: false });
        case actionTypes.GET_SEGMENT:
          return Object.assign({}, state, { isGetSegmentInProgress: false });
        case actionTypes.EDIT_SEGMENT:
          return Object.assign({}, state, { isEditSegmentInProgress: false });
        default:
          return Object.assign({}, state);
      }
    default:
      return state;
  }
}
